"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselNavStepName = void 0;
var CarouselNavStepName;
(function (CarouselNavStepName) {
    CarouselNavStepName["Address"] = "ADDRESS";
    CarouselNavStepName["Booked"] = "BOOKED";
    CarouselNavStepName["Confirm"] = "CONFIRM";
    CarouselNavStepName["Contact"] = "CONTACT";
    CarouselNavStepName["Customer"] = "CUSTOMER";
    CarouselNavStepName["Details"] = "DETAILS";
    CarouselNavStepName["Issue"] = "ISSUE";
    CarouselNavStepName["Opened"] = "OPENED";
    CarouselNavStepName["Schedule"] = "SCHEDULE";
    CarouselNavStepName["System"] = "SYSTEM";
})(CarouselNavStepName = exports.CarouselNavStepName || (exports.CarouselNavStepName = {}));
